import { Module } from 'vuex'
import { RootState } from '.'
import { Action, Getter, Mutation, namespace, State } from 'vuex-class'
import ProductItem from './product'

const _namespace = 'cart'
export const StateCart = namespace(_namespace, State)
export const GetterCart = namespace(_namespace, Getter)
export const MutationCart = namespace(_namespace, Mutation)
export const ActionCart = namespace(_namespace, Action)

export interface CartState {
  selectedItems: CartItems | null
  selectedItem: ProductItem | null
}

export interface CartItems {
  items: ProductItem[] | null
  truncated: boolean
  count: number
}

const cart = {
  namespaced: true,
  state: {
    selectedItems: { items: null, truncated: false, count: 0 },
    selectedItem: null
  },
  getters: {
    selectedItems (state: CartState): ProductItem[] | null {
      return state.selectedItems ? state.selectedItems.items : null
    },
    selectedItem (state: CartState): ProductItem | null {
      return state.selectedItem
    }
  },
  mutations: {
    setItems (state: CartState, items: CartItems | null) {
      state.selectedItems = items
    },
    setItemsArray (state: CartState, items: ProductItem[] | null) {
      if (state.selectedItems) {
        state.selectedItems.items = items
      } else {
        state.selectedItems = null
      }
    },
    setSelectedItem (state: CartState, item: ProductItem | null) {
      state.selectedItem = item
    }
    // setCartEntry (state: CartState, data: BoutiquesModel | null) {
    //   if (data) {
    //     let arrayData: BoutiquesModel[] = []
    //     if (state.entry === undefined || state.entry === null) {
    //       arrayData = [data]
    //     } else if (state.entry.items != null) {
    //       arrayData = state.entry.items
    //       arrayData.push(data)
    //     }
    //     if (state.entry) {
    //       state.entry.items = arrayData
    //     }
    //   }
    // },
    // clearCartEntry (state: CartState) {
    //   state.entry = undefined
    // }
  }
} as Module<CartState, RootState>

export default cart
